import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import FooterMessage from '../comps/footer.vue';
import * as qs from 'qs';
import showDiv from '@ivy/fts/showDiv';
import config from '../../config';
import { env } from '@ivy/fts/envInfo/envInfo';
import DetailAddress from './comps/detailAddress.vue';
import * as goodsApi from '@/api/goods';
import Pay from './comps/pay.vue';
import PayForListPopup from './comps/payForListPopup.vue';
let MyPage = class MyPage extends Vue {
    constructor() {
        super(...arguments);
        this.goldShow = false;
        this.snapshotShow = false;
        this.show = false;
        this.order = { discount_activity: {} };
        this.presellInfo = {};
        this.payTypeMapper = {};
        this.ticketInfo = {};
        this.freight = 0; // 运费
        this.exchangeCode = {};
        this.payTimer = '剩余支付时间 00:00:00';
        this.payList = [];
        this.payType = '';
        this.payFqInfo = {};
        this.jumpMap = {
            1: 'orderTracking',
            2: 'logisticsInfo',
            3: 'logisticsList',
            4: 'orderLogistics',
        };
        //赔付金额
        this.payCount = 0;
        //赔付数据
        this.payDetail = [];
    }
    get coinPrice() {
        return +(this.order.combine_pay_detail || []).find(item => item.pay_type === 'coin').pay_amount;
    }
    get realPrice() {
        if (this.isMeet) {
            let isCom = this.order.pay_type === 'combined_payment';
            if (isCom) {
                let realType = (this.order.combine_pay_detail || []).filter(item => item.pay_type !== 'coin') || [];
                return +(realType[0] || {}).pay_amount;
            }
            return this.order.paid || this.order.total_fee;
        }
        return this.order.buyer_amount;
    }
    get payIcon() {
        return order => {
            return (this.payTypeMapper[order.pay_type] &&
                this.payTypeMapper[order.pay_type].icon);
        };
    }
    get showPayName() {
        let payType = this.order.pay_type;
        if (this.order.status === 'paying') {
            if (this.order.pay_type === 'combined_payment') {
                let payInfo = (this.order.combine_pay_detail || []).find(item => item.pay_type !== 'coin') || {};
                return (this.payTypeMapper[payInfo.pay_type] &&
                    this.payTypeMapper[payInfo.pay_type].name);
            }
            else {
                return this.payTypeMapper[payType] || '微信';
            }
        }
        else {
            if (payType === 'combined_payment') {
                return (this.order.combine_pay_detail || [])
                    .map(item => {
                    let name = this.payTypeMapper[item.pay_type] &&
                        this.payTypeMapper[item.pay_type].name;
                    // return (name + '').replace('支付', '')
                    return name;
                })
                    .join(' + ');
            }
            return (this.payTypeMapper[this.order.pay_type] &&
                this.payTypeMapper[this.order.pay_type].name);
        }
    }
    get receiveInfo() {
        return {
            receiver_name: this.order.receiver_name,
            phone: this.order.receiver_phone,
            receiver_address: this.order.receiver_address,
        };
    }
    get isPaying() {
        return this.order.status === 'paying';
    }
    get canPay() {
        return (this.order.status === 'paying' && ['wechat'].includes(this.order.pay_type));
    }
    get isPresellEnd() {
        let start_time = this.presellInfo.presell_end_time &&
            this.presellInfo.presell_end_time.replace(/-/g, '/');
        return new Date(start_time).getTime() < new Date().getTime();
    }
    get isFinalStart() {
        let start_time = this.presellInfo.final_payment_start_time &&
            this.presellInfo.final_payment_start_time.replace(/-/g, '/');
        return new Date(start_time).getTime() < new Date().getTime();
    }
    get presellText() {
        return this.order.status === 'paid' || this.order.status === 'finished'
            ? '已支付'
            : this.presellInfo.presell_status === 'closed'
                ? '未支付'
                : this.isFinalStart
                    ? this.presellInfo.end_text
                    : this.presellInfo.start_text;
    }
    get finalText() {
        return this.isFinalStart
            ? this.presellInfo.end_text
            : this.presellInfo.start_text;
    }
    get actualPaid() {
        let pay = this.presellInfo && this.presellInfo.expanding_deposit > 0
            ? +this.presellInfo.discount_price - +this.presellInfo.expanding_deposit
            : +this.presellInfo.discount_price - +this.presellInfo.deposit;
        if (this.order.discount_activity.coupon) {
            pay =
                +pay - +this.order.discount_activity.coupon.discount > 0
                    ? +pay - +this.order.discount_activity.coupon.discount
                    : 0;
        }
        if (this.presellInfo.id &&
            this.order.status === 'paying_final' &&
            this.order.presellInfo &&
            this.order.presellInfo.presell_status === 'paying') {
            pay = +pay + +this.freight;
        }
        return pay;
    }
    get expandingText() {
        return this.presellInfo && +this.presellInfo.expanding_deposit < 0.01
            ? '已支付 定金抵作同价货款,不退还'
            : `已支付 ${this.presellInfo.deposit}元抵扣${this.presellInfo.expanding_deposit}元，不退还`;
    }
    get goodsItems() {
        return ((this.order &&
            this.order.items &&
            this.order.items.filter(el => el.goods_type !== 'goods_gift')) ||
            []);
    }
    // 确认订单应付/实付（订单状态判断）
    get isMeet() {
        return ['paying', 'paying_final', 'closed'].includes(this.order.status || '');
    }
    async created() {
        this.exchangeCode = await this.$axios.get('/api/goods/order/order/getInfoAfterPaid', {
            params: {
                tid: this.$route.query.tid,
            },
        });
        await env.init();
        let isLogin = await env.getIsLogin();
        if (!isLogin) {
            return await env.login();
        }
        await this.getOrder();
        await this.getTicketGoods();
        this.$title('订单详情');
        // if (this.order.status === 'paying') {
        //   this.order.pay_type = 'wechat'
        // }
        if (this.order.status === 'paying' && this.order.remain_time) {
            this.countDownHandle(this.order.remain_time);
            this.loadPayList();
        }
    }
    async loadPayList() {
        let { data } = await this.$axios.post('/api/goods/order/order/getPayTypeList', {
            skus: this.order.new_items.map(item => {
                return {
                    id: item.goods_id,
                    type: item.goods_type,
                    isTrueGroup: false,
                };
            }),
        });
        console.log('------', data);
        this.payList = data;
    }
    async getOrder() {
        await env.init();
        let { data } = await this.$axios.get(`/api/goods/shop/search/order/getOrder`, {
            params: {
                tid: this.$route.query.tid,
            },
        });
        if (data) {
            this.order = data;
            this.show = true;
            this.presellInfo = data.presellInfo || {};
            this.freight = +data.freight;
        }
        this.getPayTypes();
        this.getPayForInfo();
        this.goldShow = this.order.contian_water_pay;
        this.snapshotShow = this.order.hasSnapshot;
    }
    //获取赔付金额
    async getPayForInfo() {
        let { data } = await this.$axios.get(`/api/goods/v1/order/getOrderCompensate`, {
            params: {
                tid: this.order.tid,
            },
        });
        if (data) {
            this.payDetail = data;
            this.payDetail.forEach(item => {
                this.payCount += +item.amount;
            });
        }
    }
    showExchangeCode() {
        this.$router.push(`/payDone?tid=${this.$route.query.tid}&tp=exchangeCode`);
    }
    async getTicketGoods() {
        if (this.order.pay_type !== 'ticket')
            return;
        let { data } = await this.$axios.get(`/api/activity/weixinActivity/eCommerce/getGoodsDetail`, {
            params: {
                sku_id: this.order.items[0].goods_id,
            },
        });
        this.ticketInfo = data;
    }
    async getPayTypes() {
        const { data } = await this.$axios.get(`/api/mobile/other/setting/getSettings`, {
            params: {
                cat: 'APP_PAY',
                keys: 'pay_types',
            },
        });
        this.payTypeMapper = (data.pay_types && data.pay_types.mapper) || {};
    }
    onViewLogistics() {
        this.$router.push({
            path: '/order/logisticsMessage',
            query: { id: this.order.id },
        });
    }
    toLogistics(order) {
        this.$router.push({
            path: this.jumpMap[order.jump_type],
            query: {
                tid: this.order.tid,
                expressNum: this.order.express_num || '',
                barcode: this.order.bar_code || '',
            },
        });
    }
    async toFinalPay() {
        let start_time = this.presellInfo.final_payment_start_time &&
            this.presellInfo.final_payment_start_time.replace(/-/g, '/');
        if (new Date(start_time).getTime() > new Date().getTime())
            return;
        window.location.href = `${window.location.origin}/goods/orderConfirm?spuId=${this.presellInfo.spu_id}&skuId=${this.presellInfo.sku_id}&type=${this.presellInfo.goods_type}&orderId=${this.order.id}&from=final&receiver_id=${this.order.receiver_id}`;
    }
    // async toPay() {
    //   const { token = '' } = this.$route.query
    //   const { data } = await this.$axios.post('/api/goods/order/order/pay', {
    //     tid: this.order.tid,
    //     trade_type: isWeixin() ? undefined : 'MWEB'
    //   })
    //   const redirect = `${window.location.origin}/goods/payDone?tid=${data.tid}&token=${token}`
    //   if (+data.total_fee < 0.01) {
    //     return window.location.href = redirect
    //   }
    //   window.location.href =
    //     `//${window.location.host}/pay/?${qs.stringify({
    //       pay: data,
    //       redirect
    //     })}`
    // }
    toSnapshot() {
        this.$router.push({
            path: '/snapshotList',
            query: {
                id: this.order.id,
                tid: this.order.tid,
            },
        });
    }
    // 倒计时函数
    countDownHandle(leftTime) {
        let that = this;
        function getTime(leftTime) {
            let day = Math.floor(leftTime / 60 / 60 / 24);
            let hour = Math.floor((leftTime / 60 / 60) % 24);
            hour = hour < 10 ? '0' + hour : hour;
            let minute = Math.floor((leftTime / 60) % 60);
            minute = minute < 10 ? '0' + minute : minute;
            let second = Math.floor(leftTime % 60);
            second = second < 10 ? '0' + second : second;
            that.payTimer = `剩余支付时间 ${hour}:${minute}:${second}`;
        }
        getTime(leftTime);
        let t = setInterval(() => {
            leftTime -= 1;
            if (leftTime <= 0) {
                clearInterval(t);
                this.payTimer = '剩余支付时间 00:00:00';
                return window.location.reload();
            }
            getTime(leftTime);
        }, 1000);
    }
    async cancelOrder() {
        await goodsApi.cancelOrder({
            id: this.order.id,
        });
        window.location.reload();
    }
    updatePayType(type) {
        this.payType = type;
    }
    updatePayFqInfo(fqInfo) {
        this.payFqInfo = fqInfo;
    }
    //点击赔付金额
    async onClickPayFor() {
        if (this.payDetail.length < 2)
            return;
        await env.init();
        const isLogin = await env.getIsLogin();
        if (!isLogin) {
            this.$emit('show-shadow', true);
            return await env.login();
        }
        await showDiv(PayForListPopup, {
            visible: true,
            info: this.payDetail,
        });
    }
    async payOrder() {
        let _redirect = `${window.location.origin}/goods/payDone?tid=${this.order.tid}&toList=true`;
        if (+this.order.total_fee < 0.01) {
            return window.location.replace(_redirect);
        }
        if (this.payType === 'alipay' || this.payType === 'alipay_hb') {
            let payInfo = {
                order_id: this.order.id,
                pay_channel: 3,
                pay_type: {
                    alipay: 2,
                    alipay_hb: 17,
                }[this.payType] + '',
                sys_type: this.order.sys_type,
            };
            // let payInfo = _.pick(pay.data, [
            //   'order_id',
            //   'pay_channel',
            //   'pay_type',
            //   'is_presell_final',
            //   'discount_amount',
            //   'sys_type',
            //   'amount',
            // ])
            this.$router.push({
                path: 'orderPay',
                query: {
                    ...payInfo,
                    _redirect,
                    combine_pay: [],
                    hbfq_num: this.payFqInfo.stage || '0',
                },
            });
        }
        else {
            let pay;
            if (this.order.is_version_new) {
                pay = await goodsApi.payOrder({
                    order_id: this.order.id,
                    pay_channel: 3,
                    pay_type: 1,
                });
            }
            else {
                pay = await this.$axios.post('/api/goods/order/order/pay', {
                    tid: this.order.tid,
                });
            }
            window.location.replace(`//${config.env === 'production' ? window.location.host : 'm.ivydad.com.cn'}/pay/?${qs.stringify({
                pay: { ...pay.data },
                redirect: _redirect,
            })}`);
        }
    }
};
MyPage = tslib_1.__decorate([
    Component({
        components: {
            FooterMessage,
            DetailAddress,
            Pay,
        },
        filters: {
            state(refund_state) {
                return ({
                    FULL_REFUNDING: '退(货/款)中',
                    EXCHANGING: '换货中',
                    EXCHANGE: '换货完成',
                    EXCHANGED: '换货完成',
                    FULL_RETURN_REFUND: '退货退款完成',
                    FULL_RETURN_REFUNDING: '退货退款中',
                    FULL_REFUND: '退货退款完成（已退全款）',
                    PARTIAL_REFUND: '部分退款退货完成',
                    GROUP_DISBANDED: '拼团解散自动退款',
                    PARTIAL_REFUNDING: '部分退款退货中',
                    AFTER_SALES_CLOSED: '售后关闭',
                    NONE: '',
                }[refund_state] || '');
            },
            price(order) {
                return order.items
                    .reduce((sum, cur) => {
                    return cur.goods_type === 'goods_gift'
                        ? sum
                        : sum + +cur.num * +cur.goods_price;
                }, 0)
                    .toFixed(2);
            },
            status(val) {
                const dict = {
                    paid: '待发货',
                    shipping: '待收货',
                };
                return dict[val] || '';
            },
        },
    })
], MyPage);
export default MyPage;
